const base = import.meta.env.VITE_GATEWAY_URL ?? ''

export const GATEWAY_HTTP = base
export const GATEWAY_WS   = base.replace(/^https/, 'wss').replace(/^http/, 'ws')
